<template lang="pug">
b-container.dsg-page(fluid)
    CipPesetModal(:showCipPreset.sync="showCipPreset" :client="cipClient")

    .dsg-page-header
        div
            h1.dsg-page-title
                Icon(icon="mdi:view-dashboard-outline")
                | Dashboard
            p.dsg-page-subtitle {{ dayToday }}

    b-row
        <!-- left side : pending clients -->
        b-col.col-12.col-xl-6.mb-4
            .dsg-card.h-100
                .dsg-card-header
                    .d-flex.align-items-start.justify-content-between
                        div
                            h2.dsg-card-title New Clients
                            //- p.dsg-card-sub Review pending and not-joining clients
                        span.d-flex.align-items-center(style="gap: 0.5rem;")
                            b-spinner.text-primary(small v-if="isRefreshingClients && activeClients.length > 0")
                            b-badge.dsg-count-badge(pill) {{ activeClients.length }}
                    .dsg-tabs.mt-3
                        button.dsg-tab(:class="{ active: activeTab === 'pending' }" @click="activeTab = 'pending'") Pending
                        button.dsg-tab(:class="{ active: activeTab === 'notJoining' }" @click="activeTab = 'notJoining'") Not Joining
                .dsg-card-pad
                    div(style="max-height: 60vh; overflow-y: auto;")
                        <!-- loading -->
                        .dsg-empty(v-if="(isFetchingAdminDashboardData || isRefreshingClients) && activeClients.length === 0")
                            b-spinner(variant="primary")
                        <!-- empty -->
                        .dsg-empty(v-else-if="activeClients.length === 0")
                            Icon.dsg-empty-icon(icon="mdi:account-off-outline" width="48")
                            p.mb-0 {{ activeTab === 'pending' ? 'No pending clients' : 'No not-joining clients' }}
                        <!-- list -->
                        .dsg-pending-item(
                            v-else
                            v-for="(client, index) in activeClients"
                            :key="client.crb5c_fow_customerid || index"
                        )
                            .dsg-pending-head(
                                v-b-toggle="`collapse-${activeTab}-${index}`"
                                v-b-tooltip.hover
                                title="Click to view actions"
                            )
                                span.dsg-pending-name {{ client.crb5c_no }}
                                span.d-flex.align-items-center(style="gap: 0.5rem;")
                                    span.dsg-pill.dsg-pill-cip(v-if="client.crb5c_cipregistration") CIP
                                    Icon.dsg-chevron(icon="mdi:chevron-down" width="22")
                            b-collapse(:id="`collapse-${activeTab}-${index}`")
                                .dsg-pending-actions
                                    b-button.dsg-action-btn(
                                        variant="outline-primary"
                                        @click="$root.redirectToClientPage(client.crb5c_fow_customerid)"
                                    )
                                        Icon.mr-1(icon="mdi:account-details-outline")
                                        | Client page
                                    b-button.dsg-action-btn(
                                        variant="outline-primary"
                                        @click="$root.redirectToClientAssessment(client.crb5c_fow_customerid)"
                                    )
                                        Icon.mr-1(icon="mdi:clipboard-text-outline")
                                        | Assessment page
                                    b-button.dsg-action-btn(
                                        variant="outline-primary"
                                        @click="presetCipModal(client.crb5c_fow_customerid)"
                                    )
                                        Icon.mr-1(icon="mdi:calendar-edit")
                                        | {{ client.crb5c_cipregistration ? 'Edit CIP Preset' : 'Add CIP Preset' }}

        <!-- right side : today's schedule -->
        b-col.col-12.col-xl-6.mb-4
            .dsg-card.h-100
                .dsg-card-header.d-flex.align-items-center.justify-content-between
                    div
                        router-link.dsg-card-title.text-decoration-none(to="/weekly" style="color: var(--dsg-primary);") Today's Schedule
                        //- p.dsg-card-sub All sessions scheduled for today
                    b-badge.dsg-count-badge(pill) {{ listTodaySchedule.length }}
                .dsg-card-pad
                    div(style="max-height: 60vh; overflow-y: auto;")
                        <!-- empty -->
                        .dsg-empty(v-if="listTodaySchedule.length === 0")
                            Icon.dsg-empty-icon(icon="teenyicons:calendar-no-access-outline" width="48")
                            p.mb-0 No schedules for today
                        <!-- list -->
                        .dsg-schedule-item(
                            v-else
                            v-for="(schedule, index) in listTodaySchedule"
                            :key="schedule.crb5c_fow_sessionid || index"
                        )
                            .dsg-schedule-accent
                            .flex-grow-1
                                .dsg-schedule-name {{ schedule.crb5c_sessionname }}
                                .dsg-schedule-meta
                                    span
                                        Icon.mr-1(icon="mdi:clock-outline")
                                        | {{ formatDateToTime(schedule.crb5c_date) }}
                                    span
                                        Icon.mr-1(icon="mdi:timer-sand")
                                        | {{ schedule.formattedDuration }}
</template>

<script>
import dayjs from 'dayjs';
import isToday from "dayjs/plugin/isToday";
import { ADMIN_DASHBOARD_NAMESPACE, ACTIONS as ADMIN_DASHBOARD_ACTIONS } from '../../store/Modules/AdminDashboard/types-admin-dashboard';
import { mapState, mapActions } from 'vuex';
import { Icon } from '@iconify/vue2';
import CipPesetModal from '../../components/CipPresetModal.vue';
import focusRefresh from '../../mixins/focusRefresh';

dayjs.extend(isToday);

export default {
    components: {
        Icon,
        CipPesetModal
    },
    mixins: [focusRefresh],
    data() {
        return {
            cipClient: {},
            showCipPreset: false,
            activeTab: 'pending',
            slide: null,
            schedules: [],
            clientDB: [],
            assessmentDB: [],
            FOWarrayLength: null,
            CIParrayLength: null,
            filteredArrayLength: null,
            // listNewClientRegisteredToday: [],
            dayToday: dayjs().format('DD MMMM YYYY'),
            isRefreshingClients: false,
        }
    },
    methods: {
        ...mapActions(ADMIN_DASHBOARD_NAMESPACE, [
            ADMIN_DASHBOARD_ACTIONS.DB_GET_LIST_CLIENT,
        ]),
        // Reloads the pending and not-joining client lists. DB_GET_LIST_CLIENT
        // commits both (pending = status "Pending"), so one fetch covers both tabs.
        async refreshClientLists() {
            this.isRefreshingClients = true;
            try {
                await this[ADMIN_DASHBOARD_ACTIONS.DB_GET_LIST_CLIENT]();
            } finally {
                this.isRefreshingClients = false;
            }
        },
        // Called by the focusRefresh mixin when the user returns to the tab/window.
        onFocusRefresh() {
            this.refreshClientLists();
        },
        // async getClientDB() {
        //     try {
        //         console.log("Admin Dashboard Mounted")
        //         const { data: clientData } = await axios.get('/api/admin_dashboard/get_client');
        //         const { data: assessmentData } = await axios.get('/api/admin_dashboard/get_assessment');
        //         const filteredArray = [];

        //         // console.log("clientData: ", clientData);
        //         this.listNewClientRegisteredToday = clientData.filter(item => dayjs(item.createdon).isToday());
        //         // console.log("listNewClientRegisteredToday: ", this.listNewClientRegisteredToday);

        //         // this.clientDB = clientData
        //         //     .map((client) => {
        //         //         const clientCreatedOn = dayjs(client.createdon).format('DD MMM YYYY')
        //         //         const today = dayjs().format('DD MMM YYYY')

        //         //         const monthDiff = dayjs(today, 'DD MMM YYYY').diff(dayjs(clientCreatedOn, 'DD MMM YYYY'), 'month')

        //         //         if (monthDiff >= 0 && monthDiff <= 5) {
        //         //             filteredArray.push(clientCreatedOn)
        //         //             return {
        //         //                 filteredArray,
        //         //             }

        //         //         }
        //         //         return null;
        //         //     })
        //         //     .filter((client) => client !== null);

        //         // console.log('client database: ', this.clientDB)

        //         let FOWarray = 0;
        //         let CIParray = 0;
        //         this.assessmentDB = assessmentData.map((assessment) => {

        //             let clientProgramme = ''
        //             if (assessment.crb5c_eq5d5lform === false) {
        //                 clientProgramme = 'FOW'
        //                 FOWarray++
        //             } else {
        //                 clientProgramme = 'CIP'
        //                 CIParray++
        //             }

        //             let dateAssessment = null
        //             if (assessment.crb5c_dateofassessment === null) {
        //                 dateAssessment = 'No information'
        //             } else {
        //                 dateAssessment = dayjs(assessment.crb5c_dateofassessment).format('DD-MM-YYYY HH:mm')
        //             }

        //             let currentAssessment = ''
        //             if (clientProgramme === 'CIP') {
        //                 if (assessment.crb5c_cip1stsession === null && assessment.crb5c_cip2ndsession === null) {
        //                     currentAssessment = '14th Session Week'
        //                 } else {
        //                     currentAssessment = '6 Months'
        //                 }
        //             }
        //             if (clientProgramme === 'FOW') {
        //                 currentAssessment = '1 Year'
        //             }

        //             return {
        //                 ...assessment,
        //                 FOWarray,
        //                 CIParray,
        //                 currentAssessment: currentAssessment,
        //                 clientProgramme: clientProgramme,
        //                 dateAssessment: dateAssessment
        //             }
        //         })
        //         const FOWarrayLength = FOWarray
        //         this.FOWarrayLength = FOWarrayLength

        //         const filteredArrayLength = filteredArray.length;
        //         this.filteredArrayLength = filteredArrayLength
        //         console.log('filteredArray length: ', filteredArrayLength);
        //         console.log('assessment database: ', this.assessmentDB);

        //     } catch (error) {
        //         console.log(error)
        //         return []
        //     }
        // },
        async presetCipModal(client) {
            const { data: clientData } = await this.$store.state.api.get(`/client?clientid=${client}`);
            this.cipClient = clientData;
            this.showCipPreset = true;
        },
        formatDateToTime(rawDateISOstring){
            return dayjs(rawDateISOstring).format("hh:mm");
        },
        getSchedules(){
            this.schedules = [
                {
                    id: 1,
                },
                {
                    id: 2,
                },
            ];
        },



    },
    computed: {
        ...mapState({
            listNewClientRegisteredToday: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.listNewClientRegisteredToday),
            listClient: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.listClient),
            listUpcomingAssessment: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.listUpcomingAssessment),
            listTodaySchedule: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.listTodaySchedule),
            isFetchingAdminDashboardData: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.isFetchingAdminDashboardData),
        }),
        sortByName(){
            return (list) => [...list].sort((a, b) =>
                (a.crb5c_no || '').localeCompare(b.crb5c_no || '', undefined, { sensitivity: 'base' })
            );
        },
        sortedPendingClients(){
            return this.sortByName(this.listNewClientRegisteredToday);
        },
        // "Not Joining" clients: crb5c_client_status === 411620006
        notJoiningClients(){
            return this.sortByName(
                (this.listClient || []).filter(client => client.crb5c_client_status === 411620006)
            );
        },
        activeClients(){
            return this.activeTab === 'pending' ? this.sortedPendingClients : this.notJoiningClients;
        },
        listFOWclientAssessment(){
            return this.listUpcomingAssessment.filter(item => Boolean(!item.crb5c_eq5d5lform));
        },
        listCIPclientAssessment(){
            return this.listUpcomingAssessment.filter(item => Boolean(item.crb5c_eq5d5lform));
        },
        
    },
    async mounted() {
        this.getSchedules();
        // Refresh client lists when returning to the dashboard. Skipped on the
        // very first visit — the root initAdminDashboardData batch is already
        // fetching the same data, so refreshing here would double every query.
        if (this.$store.state.loadedAdminDashboard) {
            this.refreshClientLists();
        }
    }
}

</script>

<style scoped>
.dsg-count-badge {
    background-color: var(--dsg-secondary);
    color: #fff;
    font-size: 0.9rem;
    padding: 0.35rem 0.75rem;
}

/* tabs (Pending / Not Joining) */
.dsg-tabs {
    display: flex;
    gap: 0.4rem;
    background: #f0edf4;
    border-radius: 999px;
    padding: 0.25rem;
    width: fit-content;
}
.dsg-tab {
    border: none;
    background: transparent;
    color: var(--dsg-muted);
    font-weight: 600;
    font-size: 0.9rem;
    padding: 0.35rem 1.1rem;
    border-radius: 999px;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
}
.dsg-tab:hover {
    color: var(--dsg-primary);
}
.dsg-tab.active {
    background: #fff;
    color: var(--dsg-primary);
    box-shadow: var(--dsg-shadow-sm);
}

/* pending clients */
.dsg-pending-item {
    border: 1px solid var(--dsg-border);
    border-radius: var(--dsg-radius-sm);
    margin-bottom: 0.75rem;
    overflow: hidden;
    transition: box-shadow 0.15s ease;
}
.dsg-pending-item:hover {
    box-shadow: var(--dsg-shadow-sm);
}
.dsg-pending-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.85rem 1.1rem;
    background: #faf9fc;
    cursor: pointer;
}
.dsg-pending-name {
    font-weight: 600;
    color: var(--dsg-primary);
}
.dsg-chevron {
    color: var(--dsg-muted);
    transition: transform 0.2s ease;
}
.not-collapsed .dsg-chevron {
    transform: rotate(180deg);
}
.dsg-pending-actions {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.85rem 1.1rem;
    border-top: 1px solid var(--dsg-border);
}
.dsg-action-btn {
    font-weight: 600;
    border-radius: 10px;
    text-align: left;
    display: flex;
    align-items: center;
}

/* today's schedule */
.dsg-schedule-item {
    display: flex;
    align-items: stretch;
    gap: 0.9rem;
    background: #faf9fc;
    border: 1px solid var(--dsg-border);
    border-radius: var(--dsg-radius-sm);
    padding: 0.9rem 1.1rem;
    margin-bottom: 0.75rem;
}
.dsg-schedule-accent {
    width: 4px;
    border-radius: 4px;
    background: var(--dsg-secondary);
    flex-shrink: 0;
}
.dsg-schedule-name {
    font-weight: 600;
    color: var(--dsg-primary);
    margin-bottom: 0.35rem;
}
.dsg-schedule-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 1.25rem;
    color: var(--dsg-muted);
    font-size: 0.9rem;
}
.dsg-schedule-meta span {
    display: inline-flex;
    align-items: center;
}
</style>